module.exports = __webpack_public_path__ + "img/premium-indicator.dec08b1b.png";